var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { "margin-bottom": "15px" } }, [
        _c("span", { staticClass: "common-title" }, [_vm._v("基础资产")]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-color-blue pointer right-oper",
            on: {
              click: function($event) {
                _vm.showMore = !_vm.showMore
              }
            }
          },
          [
            _vm._v(
              "\n      " + _vm._s(_vm.showMore ? "收起" : "展开") + "\n      "
            ),
            _c("a-icon", {
              staticStyle: { "font-size": "12px" },
              attrs: { type: _vm.showMore ? "up" : "down" }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "table-common" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("单据类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("单据编号")]),
            _vm._v(" "),
            _c("th", [_vm._v("应付金额（元）")]),
            _vm._v(" "),
            _c("th", [_vm._v("起始日期")]),
            _vm._v(" "),
            _c("th", [_vm._v("合同编号")]),
            _vm._v(" "),
            _c("th", [_vm._v("相关凭证")]),
            _vm._v(" "),
            _c("th", [
              _vm.getBuyOrSell == "buyer"
                ? _c("span", [_vm._v("卖方名称")])
                : _c("span", [_vm._v("买方名称")])
            ]),
            _vm._v(" "),
            _c("th", [_vm._v("祺信金额（元）")])
          ])
        ]),
        _vm._v(" "),
        _vm.showMore
          ? _c(
              "tbody",
              [
                _vm._l(_vm.pageData, function(item, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [
                      _vm._v(_vm._s(_vm._f("docIdFilter")(item.docTpCd)))
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.goldData.firstGldId == _vm.gldId
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.invoiceInfoOpen(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.docId || item.invoiceNumber))]
                          )
                        : _c("span", [
                            _vm._v(_vm._s(item.docId || item.invoiceNumber))
                          ])
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm._f("splitK")(item.rcvbAmt)))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormat")(item.rcvbStDt, "YYYY-mm-dd")
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.goldData.firstGldId == _vm.gldId
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.contractInfoOpen(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.trdCtrId))]
                          )
                        : _c("span", [_vm._v(_vm._s(item.trdCtrId))])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.goldData.firstGldId == _vm.gldId
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.voucherInfoOpen(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.voucherCodes))]
                          )
                        : _c("span", [_vm._v(_vm._s(item.voucherCodes))])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm.getBuyOrSell == "buyer"
                        ? _c("span", [_vm._v(_vm._s(item.cstIdNm))])
                        : _c("span", [_vm._v(_vm._s(item.cntprIdNm))])
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm._f("splitK")(item.estbAmt)))])
                  ])
                }),
                _vm._v(" "),
                _vm.pageData.length == 0
                  ? _c("tr", [
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { colspan: "8" }
                        },
                        [_vm._v("暂无数据")]
                      )
                    ])
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.showMore ? _c("tbody", [_vm._m(0)]) : _vm._e()
      ]),
      _vm._v(" "),
      _c("contractDialog", {
        ref: "contractInfo",
        attrs: { title: "合同详情", readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("invoiceInfo", {
        ref: "invoiceInfo",
        attrs: { readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("deliveryVoucherDialog", { ref: "deliveryVoucherDialog" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c(
        "td",
        {
          staticStyle: {
            "text-align": "center",
            color: "#999",
            "font-size": "18px"
          },
          attrs: { colspan: "8" }
        },
        [_vm._v("\n          ···\n        ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47405f73", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47405f73","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gold-page/gold-detail-origin-info.vue
// module id = eiqZ
// module chunks = 1